import React from 'react';
import './Gallery.css';
// Import the 3-month images
import threeMonth1 from '../assets/images/3month-1.jpeg';
import threeMonth2 from '../assets/images/3month-2.jpeg';
import threeMonth3 from '../assets/images/3month-3.jpeg';
import threeMonth4 from '../assets/images/3month-4.jpeg';
import placeholderImg from '../assets/images/1.jpeg';

function Gallery() {
  // Placeholder data for gallery
  const months = [
    { id: 1, name: 'Месяц 1' },
    { id: 2, name: 'Месяц 2' },
    { id: 3, name: 'Месяц 3' }
  ];

  const photos = [
    { id: 1, month: 1, title: 'Первые дни', image: placeholderImg },
    { id: 2, month: 1, title: 'Первая улыбка', image: placeholderImg },
    { id: 3, month: 1, title: 'С мамой', image: placeholderImg },
    { id: 4, month: 1, title: 'С папой', image: placeholderImg },
    { id: 5, month: 2, title: 'Играем', image: placeholderImg },
    { id: 6, month: 2, title: 'Спим', image: placeholderImg },
    { id: 7, month: 3, title: 'Гуляем', image: threeMonth1 },
    { id: 8, month: 3, title: 'Купаемся', image: threeMonth2 },
    { id: 9, month: 3, title: 'Улыбаемся', image: threeMonth3 },
    { id: 10, month: 3, title: 'Растем', image: threeMonth4 }
  ];

  const [selectedMonth, setSelectedMonth] = React.useState(1);

  return (
    <div className="container">
      <h1 className="page-title">Фотогалерея</h1>
      
      <div className="gallery-nav">
        {months.map(month => (
          <button
            key={month.id}
            className={`gallery-nav-button ${selectedMonth === month.id ? 'active' : ''}`}
            onClick={() => setSelectedMonth(month.id)}
          >
            {month.name}
          </button>
        ))}
      </div>
      
      <div className="gallery-grid">
        {photos
          .filter(photo => photo.month === selectedMonth)
          .map(photo => (
            <div key={photo.id} className="photo-card">
              <div className="photo-container">
                <img src={photo.image} alt={photo.title} className="photo-image" />
              </div>
              <p className="photo-title">{photo.title}</p>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Gallery; 